import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Calculates the number of days remaining in a trial period
 * @param trialEndDate - The trial end date in UTC format (e.g. "2025-05-13T14:59:54.978Z")
 * @param userTimezone - The user's timezone (e.g. "America/New_York")
 * @returns The number of days remaining in the trial period
 */
export const getTrialTimeRemaining = (
	trialEndDate: string,
	userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
): { value: number; unit: "day" | "hour" | "minute" } | null => {
	const trialEnd = dayjs.utc(trialEndDate).tz(userTimezone);
	const now = dayjs().tz(userTimezone);

	if (!trialEnd.isValid() || !now.isValid()) {
		return null;
	}

	const days = trialEnd.diff(now, "day");
	if (days > 0) {
		return { value: days, unit: "day" };
	}

	const hours = trialEnd.diff(now, "hour");
	if (hours > 0) {
		return { value: hours, unit: "hour" };
	}

	const minutes = trialEnd.diff(now, "minute");
	if (minutes > 0) {
		return { value: minutes, unit: "minute" };
	}

	return null;
};
